import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import logo from './img/up_logo.svg';
import { FaUserAlt, FaUnlockAlt, FaFacebookF, FaGoogle } from "react-icons/fa";
import { Link } from "react-router-dom";

function Registro() {
  return (
    <div className='fondo_principal d-flex align-items-center justify-content-center'>
      <div className='d-flex flex-column  text-center'>
        <img src={logo} className="mini_logo" alt="logo" />
        <h1 className='py-4 my-4'>Hola</h1>
        <form>
          <div className='form-group mb-3'>
            <label htmlFor='correo'><FaUserAlt /> Agregar un correo</label>
            <input type='text' name='correo' className='form-control form-inicio'/>
          </div>
          <div className='form-group mb-3'>
            <label htmlFor='correo'><FaUserAlt /> ¿Cuál es tu nombre?</label>
            <input type='text' name='correo' className='form-control form-inicio'/>
          </div>
          <div className='form-group mb-3'>
            <label htmlFor='correo'><FaUserAlt /> ¿Cuál es tu correo?</label>
            <input type='text' name='correo' className='form-control form-inicio'/>
          </div>
          <div className='form-group mb-3'>
            <label htmlFor='pass'><FaUnlockAlt /> Elije una Contraseña</label>
            <input type='password' name='pass' className='form-control form-inicio'/>
          </div>
          <button type='button' className='btn btn-outline-light my-2'>Registrarme</button>
        </form>
        <hr/>
        <button className='btn btn-link mb-3 text-white'><FaFacebookF /> Continuar con Facebook</button>
        <button className='btn btn-link mb-3 text-white'><FaGoogle /> Continuar con Google</button>
        <Link to="/termometro">Termometro</Link>
      </div>
    </div>
  );
}

export default Registro;
